declare const NG: {
  ready(): Promise<void>;
  auth: {
    login(): Promise<{
      id: string;
      display_name: string;
      email: string;
      avatar_url: string;
    }>;
  };
  notify: {
    send(opts: { title: string; body: string }): Promise<void>;
  };
  storage: {
    get(key: string): Promise<string | null>;
    set(key: string, value: string): Promise<void>;
    del(key: string): Promise<void>;
  };
  theme: {
    get(): Promise<'light' | 'dark'>;
  };
};

let isInsideNG: boolean | undefined;

export async function isNGDesktop(): Promise<boolean> {
  if (isInsideNG !== undefined) return isInsideNG;
  try {
    if (typeof NG === 'undefined') {
      isInsideNG = false;
      return false;
    }
    await NG.ready();
    isInsideNG = true;
    return true;
  } catch {
    isInsideNG = false;
    return false;
  }
}

export async function ngLogin() {
  if (!await isNGDesktop()) return undefined;
  return NG.auth.login();
}

export async function ngNotify(title: string, body: string) {
  if (!await isNGDesktop()) return;
  return NG.notify.send({ title, body });
}

export async function ngGetTheme() {
  if (!await isNGDesktop()) return undefined;
  return NG.theme.get();
}

export async function ngStorageGet(key: string) {
  if (!await isNGDesktop()) return null;
  return NG.storage.get(key);
}

export async function ngStorageSet(key: string, value: string) {
  if (!await isNGDesktop()) return;
  return NG.storage.set(key, value);
}
